import React from 'react'
import PropTypes from 'prop-types'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'

const HelpPopover = props => {
  const overlayContent = (
    <Popover id={props.id} title={props.title}>
      {props.children}
    </Popover>
  )

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={overlayContent}
    >
      <Button bsStyle="link">
        <span className="fas fa-info-circle" /> Help
      </Button>
    </OverlayTrigger>
  )
}

HelpPopover.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
}

HelpPopover.defaultProps = {
  title: 'Help',
}

export default HelpPopover
